import {Box} from '@indoqa/style-system'
import {IStyle} from 'fela'
import {useFela} from 'react-fela'
import {Theme} from '../../../app/theme'
import {ArAnsprechpartnerCard} from './ArAnsprechpartnerCard'

interface ArAnsprechpartnerSectionProps {
  readonly intro: string
}

const CARD_COLUMN_GAP = 80

const CONTACTS = [
  {
    name: 'Roman Huditsch',
    role: 'Betriebsratsservice',
    email: 'roman.huditsch@oegbverlag.at',
    phone: '+43 664 781 151 74',
    photo: 'huditsch.webp',
  },
  {
    name: 'Robert Leonhardt',
    role: 'Betriebsratsservice',
    email: 'robert.leonhardt@oegbverlag.at',
    phone: '+43 664 814 63 82',
    photo: 'leonhardt.webp',
  },
]

export function ArAnsprechpartnerSection({intro}: ArAnsprechpartnerSectionProps) {
  const {css, theme} = useFela<Theme>()

  const cardsStyle: IStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing.space6,
    paddingTop: theme.spacing.space4,
    tablet: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'center',
      columnGap: CARD_COLUMN_GAP,
    },
  }

  return (
    <>
      <Box pt={6}>
        <h2>Deine persönlichen Ansprechpartner:</h2>
      </Box>
      <p>{intro}</p>
      <div className={css(cardsStyle)}>
        {CONTACTS.map((contact) => (
          <ArAnsprechpartnerCard key={contact.email} {...contact} />
        ))}
      </div>
    </>
  )
}
